import React, { useEffect, useState } from "react";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import GridLayout from "react-grid-layout";
import { LevelList } from "./LevelList";
import { Recorder } from "./Recorder";
import { EditorTabs } from "./EditorTabs";
import { PaintingToolTab } from "./PaintingToolTab";
import { EntityPalette } from "./EntityPalette";
import { Inspector } from "./Inspector";
const localStorageKey = "AnewLayout";
import "./DevUI.scss";

export const App = () => {
  const [width, setWidth] = useState(1600);
  const [layout, _] = useState(getFromLS(localStorageKey));
  const [layoutLock, setlayoutLock] = useState(false);
  useEffect(() => {
    window.addEventListener("resize", (e) => {
      setWidth(document.body.clientWidth);
    });
  });

  return (
    <div>
      <nav>
        <button onClick={() => setlayoutLock(!layoutLock)}>
          {layoutLock ? "Lock Layout" : "Unlock Layout"}
        </button>
      </nav>
      <GridLayout
        className="layout"
        layout={layout}
        cols={8}
        width={width}
        onLayoutChange={(layout) => saveToLS(localStorageKey, layout)}
        rowHeight={100}
        isDraggable={layoutLock}
        isResizable={layoutLock}
      >
        <div key="modes-toolbar">
          <EditorTabs />
        </div>
        <div key="game">
          <div id="game-container"></div>
        </div>
        <div key="levelList">
          <LevelList />
        </div>
        <div key="levelPainting">
          <PaintingToolTab />
        </div>
        <div key="entityToolbar">
          <EntityPalette />
        </div>
        <div key="recorder">
          <Recorder />
        </div>
        <div key="inspector">
          <Inspector />
        </div>
      </GridLayout>
    </div>
  );
};

function getFromLS(key: string) {
  if (localStorage) {
    const ls = JSON.parse(localStorage.getItem(key) as string);
    if (ls === null) {
      return [
        { i: "game", x: 2, y: 0, w: 2, h: 4 },
        { i: "levelList", x: 0, y: 1, w: 2, h: 4 },
        { i: "recorder", x: 4, y: 2, w: 1, h: 4 },
        { i: "modes-toolbar", x: 2, y: 0, w: 2, h: 1 },
        { i: "levelPainting", x: 4, y: 1, w: 1, h: 4 },
        { i: "entityToolbar", x: 4, y: 1, w: 1, h: 4 },
        { i: "inspector", x: 5, y: 1, w: 1, h: 4 },
      ];
    }
    console.log("returning with", ls);
    return ls;
  }
}

function saveToLS(key: string, value: any) {
  if (localStorage) {
    localStorage.setItem(key, JSON.stringify(value));
  }
}
